var _regeneratorRuntime = require("C:/Users/bmagr/Desktop/Programming/GitHub/vid2gif-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("C:/Users/bmagr/Desktop/Programming/GitHub/vid2gif-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var resolveURL = require('resolve-url');

var _require = require('../utils/log'),
    log = _require.log;

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _corePath, corePath, workerBlob;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _corePath = _ref.corePath;

            if (!(typeof window.createFFmpegCore === 'undefined')) {
              _context.next = 13;
              break;
            }

            log('info', 'fetch ffmpeg-core.worker.js script');
            corePath = resolveURL(_corePath);
            _context.next = 6;
            return fetch(corePath.replace('ffmpeg-core.js', 'ffmpeg-core.worker.js'));

          case 6:
            _context.next = 8;
            return _context.sent.blob();

          case 8:
            workerBlob = _context.sent;
            window.FFMPEG_CORE_WORKER_SCRIPT = URL.createObjectURL(workerBlob);
            log('info', "worker object URL=".concat(window.FFMPEG_CORE_WORKER_SCRIPT));
            log('info', "download ffmpeg-core script (~25 MB) from ".concat(corePath));
            return _context.abrupt("return", new Promise(function (resolve) {
              var script = document.createElement('script');

              var eventHandler = function eventHandler() {
                script.removeEventListener('load', eventHandler);
                log('info', 'initialize ffmpeg-core');
                resolve(window.createFFmpegCore);
              };

              script.src = corePath;
              script.type = 'text/javascript';
              script.addEventListener('load', eventHandler);
              document.getElementsByTagName('head')[0].appendChild(script);
            }));

          case 13:
            log('info', 'ffmpeg-core is loaded already');
            return _context.abrupt("return", Promise.resolve(window.createFFmpegCore));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();